// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"vO-z","categoryName":"wO-z","categoryNameSearchHeader":"xO-z","categoryContent":"yO-z","bottomAligned":"zO-z","image":"AO-z","imageNoBackground":"BO-z"};